<template>
  <div>
    <template v-if="model">
      <vk-icon :icon="model" />
    </template>
  </div>
</template>

<script>
export default {
  name: "icon",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
